import React from 'react';
import { Text } from 'react-native';
import Animated from 'react-native-reanimated';
import i18n from 'i18n-js';

import Svg from '@styles/icons/svg';

import { WithColor } from '@styles/colors';

import type { SendStatusInput, ScaleFontProps } from '@components/search/operations/components/StartJobPopup/types';
import { SEND_STATUS_CONTENT_KIND, SEND_STATUS_CELL_HEIGHT } from './constants';
import { resolveSendStatusContent } from './helpers/resolveSendStatusContent';
import { useManageSendStatus } from './hooks/useManageSendStatus';
import ShimmerLabel from './components/ShimmerLabel';

type SendStatusProps = WithColor & SendStatusInput & Required<ScaleFontProps>;

const SendStatus = ({ status, id, messageStorage, C, scale, font }: SendStatusProps) => {
  const content = resolveSendStatusContent({ status, id, messageStorage });

  const isPending = content?.kind === SEND_STATUS_CONTENT_KIND.Pending;
  const isBadge = content?.kind === SEND_STATUS_CONTENT_KIND.Badge;
  const { badgeAnimatedStyle } = useManageSendStatus({ isBadgeVisible: isBadge });

  if (!content) return null;

  if (isPending) {
    return <ShimmerLabel content={content} C={C} scale={scale} font={font} />;
  }

  if (isBadge) {
    return (
      <Animated.View
        style={[
          badgeAnimatedStyle,
          {
            paddingHorizontal: scale(13),
            height: scale(SEND_STATUS_CELL_HEIGHT),
            backgroundColor: C('Status/Light/Active'),
            borderRadius: scale(15),
            flexDirection: 'row',
            alignItems: 'center',
          },
        ]}
      >
        <Svg icon="checkboxGrey" width={16} height={16} color="Button/Light/Primary Text" />
        <Text style={[font['Button 2'], { color: C('Button/Light/Primary Text'), marginLeft: scale(7) }]}>{i18n.t('Selected On Machine')}</Text>
      </Animated.View>
    );
  }

  return <Text style={[font['Button 2'], { color: C(content.color) }]}>{content.label}</Text>;
};

export default SendStatus;
